import { Container } from '@cleartrip/ct-design-components'
import { Stencil } from '@/components/common/Stencil'
import React, { memo } from 'react'

const RepeatingItems = memo(() => (
    <Container className="my-3">
        <Stencil shimmer height={20} width={76} borderRadius={6} className="mb-3"/>
        <Stencil shimmer height={20} width={191} borderRadius={6}  className="mb-3"/>
        <Stencil shimmer height={20} width={191} borderRadius={6}  className="mb-3"/>
    </Container>
))

const LoadersCard = memo(() => (
    <Container className="mb-5">
        <Stencil shimmer height={16} width={258} borderRadius={6} className="mb-5" />
        <RepeatingItems />
        <RepeatingItems />
    </Container>
))

function FiltersLoader() {
    return (
        <Container className="px-4 pb-8 pt-5" >
            <Stencil shimmer height={24} width={258} borderRadius={6} className="mb-8" />
            <Container className="flex flex-column">
                <LoadersCard />
                <LoadersCard />
                <LoadersCard />
                <LoadersCard />
                <LoadersCard />
            </Container>
        </Container>
    )
}

export default FiltersLoader